import { render, staticRenderFns } from "./monitor-play.vue?vue&type=template&id=2c895db4&"
import script from "./monitor-play.vue?vue&type=script&lang=js&"
export * from "./monitor-play.vue?vue&type=script&lang=js&"
import style0 from "./monitor-play.vue?vue&type=style&index=0&id=2c895db4&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports